export enum EColorHex {
  Red = '#EA0D0D',
  Orange = '#FB6F24',
  Yellow = '#FBF21A',
  Green = '#24D024',
  Blue = '#00BBFF',
  Indigo = '#0A53DE',
  Violet = '#8934B8'
}

export enum EColor {
  Red = 'red',
  Orange = 'orange',
  Yellow = 'yellow',
  Green = 'green',
  Blue = 'blue',
  Indigo = 'indigo',
  Violet = 'violet'
}

export const colors = [
  EColor.Red,
  EColor.Orange,
  EColor.Yellow,
  EColor.Green,
  EColor.Blue,
  EColor.Indigo,
  EColor.Violet
]
